import { render, staticRenderFns } from "./BaseAppNotifications.vue?vue&type=template&id=1b395828&scoped=true"
import script from "./BaseAppNotifications.vue?vue&type=script&lang=js"
export * from "./BaseAppNotifications.vue?vue&type=script&lang=js"
import style0 from "./BaseAppNotifications.vue?vue&type=style&index=0&id=1b395828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b395828",
  null
  
)

export default component.exports